import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import GrupoUsuariosService from "service/administracao/cadastro/GrupoUsuariosService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const grupoUsuariosService = new GrupoUsuariosService();

export default function GrupoUsuariosListagem() {

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={grupoUsuariosService} urlService="/grupoUsuarios" tituloPagina={'Grupos de usuários'} defaultFilters={defaultFilters} showClearFilterButton nome="grupoUsuarios" >
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
        </BaseListagem>
    )
}
